interface AnalyticsScriptOptions {
  key: string
  src: string
  storagePrefixes: readonly string[]
  // Also governs retention: while false, the vendor's storage is purged, not merely left unwritten.
  enabled?: MaybeRefOrGetter<boolean>
}

export function useAnalyticsScript({ key, src, storagePrefixes, enabled }: AnalyticsScriptOptions) {
  const { analytics, resolved } = useCookieConsent()
  const canLoad = computed(() => analytics.value && toValue(enabled ?? true))

  const script = useScript({ key, src }, {
    trigger: useScriptTriggerConsent({ consent: canLoad }),
  })

  watchEffect(() => {
    if (!resolved.value || canLoad.value || script.status.value !== 'awaitingLoad') {
      return
    }

    purgeStorage(storagePrefixes)
  })

  watch(analytics, (granted, wasGranted) => {
    if (granted || !wasGranted) {
      return
    }

    // Vendor SDKs flush their queues on unload, so purge after they run.
    window.addEventListener('pagehide', () => purgeStorage(storagePrefixes), { once: true })
    window.location.reload()
  })

  return script
}
